import { render, staticRenderFns } from "./MFACheck.vue?vue&type=template&id=07e9160b&scoped=true&"
import script from "./MFACheck.vue?vue&type=script&lang=ts&"
export * from "./MFACheck.vue?vue&type=script&lang=ts&"
import style0 from "./MFACheck.vue?vue&type=style&index=0&id=07e9160b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e9160b",
  null
  
)

export default component.exports